
<div class="data-orderline">

  <div class="column column-image">
      <app-image class="line-image"
                  width="340"
                  heigth="225"
                  [src]="productImage"
                  [alt]="productName">
      </app-image>
  </div>

  <div class="column column-description">
      <span class="fields">{{productName}}</span>
      <span class="fields" *ngIf="productSubtitle">{{productSubtitle}}</span>
      <span class="fields productnumber">{{productNumber}}</span>
  </div>

  <div class="column column-deliverydata text-right">

    <a href="javascript:void(0)" class="delivery-amount btn btn-expand" (click)="showDeliveriesDetails = !showDeliveriesDetails"><span class="delivered">{{ delivered }}</span> / <span class="open">{{ outstanding }}</span> <i class="fa fa-angle-down"></i></a>

  </div>

  <div class="column column-price text-right">
    <span *ngIf="canBuy">{{ currentPrice.price | price:currentPrice.currency }}</span>
  </div>

  <div class="column column-quantity text-right" *ngIf="canBuy">

    <app-quantity-picker-animated
      [value]="actualQuantity"
      [minQuantity]="minQuantity"
      (quantityChanged)="quantityChanged($event)"
      [stepping]="stepping">
    </app-quantity-picker-animated>

    <!--
    <app-quantity-picker  *ngIf="canBuy"
                          [value]="actualQuantity"
                          [minQuantity]="minQuantity"
                          [stepping]="stepping"
                          (quantityChanged)="quantityChanged($event)">
    </app-quantity-picker>
    -->

  </div>
</div>

<div class="delivery-data"  *ngIf="showDeliveriesDetails">

  <div class="delivered">

    <!-- left -->
    <h2>{{ 'orders.delivered' | translate }}</h2>
    <table>
        <tr>
          <th>{{ 'orders.delivered-in' | translate }}</th>
          <th>{{ 'order.quantity' | translate }}</th>
        </tr>
        <ng-container *ngIf="hasDelivered">
          <tr *ngFor="let delivery of iterablePast">
            <td>{{delivery.month}}</td>
            <td>{{delivery.count}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!hasDelivered">
          <tr>
            <td>-</td>
            <td>-</td>
          </tr>
        </ng-container>
    </table>

  </div>
  <div class="open">

    <!-- right -->
    <h2>{{ 'orders.open' | translate }}</h2>
    <table>
      <tr>
        <th>{{ 'orders.expected' | translate }}</th>
        <th>{{ 'order.quantity' | translate }}</th>
      </tr>
      <ng-container *ngIf="hasOutstanding">
        <tr *ngFor="let delivery of futureDeliveries">
          <td *ngIf="delivery.status !== 'instock'">{{ 'orders.week' | translate }} {{ delivery.expectedWeek }} - {{ delivery.expectedYear }}</td>
          <td *ngIf="delivery.status === 'instock'">{{ 'orders.instock' | translate }}</td>
          <td>{{delivery.count}}</td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!hasOutstanding">
        <tr>
          <td>-</td>
          <td>-</td>
        </tr>
      </ng-container>
    </table>
  </div>

</div>
